/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Ambiguous_NoteInputs */

const cs_pm_ambiguous_note = /** @type {(inputs: Pm_Ambiguous_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejistá shoda: několik nemovitostí vypadá podobně nebo chybí údaje. Zkontrolujte kandidáty.`)
};

const en_pm_ambiguous_note = /** @type {(inputs: Pm_Ambiguous_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsure match: several properties look alike or data is missing. Check the candidates.`)
};

/**
* | output |
* | --- |
* | "Unsure match: several properties look alike or data is missing. Check the candidates." |
*
* @param {Pm_Ambiguous_NoteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_ambiguous_note = /** @type {((inputs?: Pm_Ambiguous_NoteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Ambiguous_NoteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_ambiguous_note(inputs)
	return cs_pm_ambiguous_note(inputs)
});